<ng-container *ngIf="yourCourseData$ | async as yourCourseData">
  <lx-card-container
    type="course"
    i18n-title
    title="Your course"
    [loading]="loading()"
    actionMode="edit"
    [endPrice]="yourCourseData.endPrice"
    [price]="yourCourseData.price"
    [currency]="currency?.()"
    [discount]="yourCourseData.discountTotalAsPercentage"
    (buttonClick)="openDialog()"
    [gaEventName]="dataLayerEventName"
    data-qa="yourCourse_card"
  >
    <div class="your-course-card">
      <div class="your-course-card__list">
        <div class="your-course-card__item" data-qa="your-course-card-location" *ngIf="(activeFlow$ | async) !== Flows.Online">
          <div class="your-course-card__item__title" i18n>Location</div>
          <div class="your-course-card__item__description">
            <div class="your-course-card__item__description__country-name">{{ yourCourseData.countryName }}</div>
            {{ yourCourseData.schoolName }}
          </div>
        </div>
        <div class="your-course-card__item" data-qa="your-course-card-course">
          <div class="your-course-card__item__title" i18n>Course</div>
          <div class="your-course-card__item__description" i18n>
            {{ yourCourseData.name }}
          </div>
        </div>
        <div class="your-course-card__item" data-qa="your-course-card-course" *ngIf="yourCourseData.selectedTimezone">
          <div class="your-course-card__item__title" i18n>Time zone</div>
          <div class="your-course-card__item__description" i18n>
            {{ yourCourseData.selectedTimezone?.name }}
          </div>
        </div>
        <div class="your-course-card__item" data-qa="your-course-card-course" *ngIf="yourCourseData.selectedClassTime">
          <div class="your-course-card__item__title" i18n>Class time</div>
          <div class="your-course-card__item__description" i18n>
            <ng-container *ngIf="yourCourseData.selectedClassTime.startTime; else decideLater">
              {{ yourCourseData.selectedClassTime.startTime | lxOffsetTime : yourCourseData.selectedTimezone?.timezoneOffset }} -
              {{ yourCourseData.selectedClassTime.endTime | lxOffsetTime : yourCourseData.selectedTimezone?.timezoneOffset }}
            </ng-container>
            <ng-template #decideLater>
              {{ yourCourseData.selectedClassTime.label }}
            </ng-template>
          </div>
        </div>
        <div class="your-course-card__item" data-qa="your-course-card-study-period">
          <div class="your-course-card__item__title" i18n>Study period</div>
          <div class="your-course-card__item__description">
            {{ yourCourseData.startDate | lxStudyPeriod : yourCourseData.endDate : yourCourseData.units }}
          </div>
        </div>
      </div>
    </div>
  </lx-card-container>

  <!--Used ngIf to force components destruction and recreation when the dialog is shown or hidden. To clear all subscriptions to store selectors and start the component from scratch.-->
  <lx-side-panel
    i18n-title
    title="Select a program"
    *ngIf="dialogVisible"
    [visible]="dialogVisible"
    [footerButtonDisabled]="!validCoursePayload"
    [activeFlow]="activeFlow$ | async"
    size="large"
    (hiddenPanel)="hideDialog()"
    footerButtonText="Apply"
    i18n-footerButtonText
    (footerButtonClicked)="saveCourseSelection()"
  >
    <ng-container [ngSwitch]="activeFlow$ | async">
      <lx-language-schools
        *ngSwitchCase="'adult'"
        (validCoursePayload)="updateValidityCoursePayload($event)"
        (coursePayload)="updateCoursePayload($event)"
      ></lx-language-schools>

      <lx-language-camps
        *ngSwitchCase="'junior'"
        [withDescription]="false"
        (validCoursePayload)="updateValidityCoursePayload($event)"
        (coursePayload)="updateCoursePayload($event)"
      ></lx-language-camps>

      <lx-online-courses *ngSwitchCase="'online'" (validCoursePayload)="updateValidityCoursePayload($event)" (coursePayload)="updateCoursePayload($event)">
      </lx-online-courses>
    </ng-container>
  </lx-side-panel>
</ng-container>
